<template>
  <div>
    <div class="custom-main" v-if="resultList.length">
      <div class="tip">*仅展示近一年的检验报告，查看更多请到窗口查询</div>
      <div class="list" v-for="(item, index) in resultList" :key="index">
        <div class="list-item" @click="toDetail(item)">
          <div>
            <div class="check-name">
              <div class="til">检验项目：</div>
              <div class="text">{{ item.ITEM_NAME }}</div>
            </div>
            <div class="check-time">
              <div class="til">检验时间：</div>
              <div class="text">{{ item.TEST_TIME }}</div>
            </div>
          </div>
          <div>
            <div class="detail">查看详情</div>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-empty" v-else>
      <van-empty
        image="https://img.yzcdn.cn/vant/custom-empty-image.png"
        description="暂无数据"
      >
      </van-empty>
    </div>
  </div>
</template>

<script>
import { getLisList } from '@/api/api'
import { Toast } from 'vant'
export default {
  data() {
    return {
      resultList: []
    }
  },
  mounted() {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      duration: 3000
    })
    getLisList({ patientId: this.$route.query.patientId })
      .then(res => {
        if (res.code == 200) {
          this.resultList = JSON.parse(res.msg).map(item => {
            item.TEST_TIME = this.formatDate(item.TEST_TIME, 'yyyy-MM-dd')
            return item
          })
        } else {
          Toast.fail('系统异常')
        }
      })
      .catch(err => {
        console.log(err)
        Toast.fail('系统异常')
      })
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        name: 'resultLis',
        query: {
          patientId: this.$route.query.patientId,
          seqNo: item.SEQ_NO,
          ITEM_NAME: item.ITEM_NAME
        }
      })
    },
    formatDate(timestamp, format) {
      // 将时间戳转换为日期对象
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hours = date.getHours()
      const minutes = date.getMinutes()
      const seconds = date.getSeconds()

      // 替换需要的时间格式
      format = format.replace('yyyy', year)
      format = format.replace('MM', month < 10 ? '0' + month : month)
      format = format.replace('dd', day < 10 ? '0' + day : day)
      format = format.replace('HH', hours < 10 ? '0' + hours : hours)
      format = format.replace('mm', minutes < 10 ? '0' + minutes : minutes)
      format = format.replace('ss', seconds < 10 ? '0' + seconds : seconds)

      return format
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-main {
  width: 100vw;
  height: 100vh;
  background: rgb(242, 248, 253);
}
.tip {
  background: #fff;
  color: rgb(248, 48, 48);
  height: 30px;
  text-align: center;
  line-height: 30px;
}
.list-item {
  background: #fff;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}
.check-name,
.check-time {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  .til {
    color: #666;
  }
  .text {
    flex: 1;
  }
}

.custom-empty {
  height: calc(100vh - 85px);
  overflow-y: auto;
}

.van-empty__image {
  width: 160px;
  height: 160px;
}

.van-empty__description {
  font-size: 18px;
}

.detail {
  color: rgb(0, 38, 255);
  font-size: 18px;
}
</style>
